import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Button, Flex, MIcon, MobHideSpan, PopClose } from './Uikit';
import { useToasts } from "react-toast-notifications";
import { MetaContext } from "../context";
import Emoji from "react-emoji-render";

export function StackName({ title, deleteHandler, closeHandler, copyHandler }) {
  const context = useContext(MetaContext);

  const { addToast } = useToasts();
  const inp = useRef();
  const inpHidden = useRef();

  const [focused, setFocused] = useState(false);
  const [stackName, setStackName] = useState("");
  const [inpWidth, setInpWidth] = useState(0);

  useEffect(() => {
    if (focused) {
      inp.current.select();
      inp.current.focus();
    }
  }, [focused]);

  useEffect(() => {
    if (context.handles.getStack("title") !== stackName) {
      setStackName(context.handles.getStack("title"));
      setInpWidth(
        getTextWidth(context.handles.getStack("title"), "bold 33px Arial")
      );
    }
  }, [context]);

  const fixName = (newName) => {
    newName = newName
      .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "")
      .replace(/ +/g, " ");
    if (newName.length > 60) newName.length = 60;
    return newName;
  };
  const saveName = (stackName) => {
    stackName = stackName.trim();
    context.handles.saveStackName(stackName);
    setFocused(false);
    addToast("New name saved", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 800,
    });
  };
  const validateName = (newName) => {
    if (!newName) newName = "";

    if (newName.length < 3) {
      addToast("Name is too short", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 800,
      });
      return false;
    } else {
      return true;
    }
  };

  const getTextWidth = (text, font) => {
    // re-use canvas object for better performance
    let canvas =
      getTextWidth.canvas ||
      (getTextWidth.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    context.font = font;
    let metrics = context.measureText(text);
    return metrics.width;
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      validateName(stackName) ? saveName(stackName) : void 0;
    }
  };

  return (
    <>
      <CSSh left style={{ flexGrow: 0 }}>
        {/* <Emoji text={stackName}/> */}
        <CSSname
          onKeyDown={handleKeyDown}
          ref={inp}
          type="text"
          value={stackName}
          width={inpWidth}
          focused={focused}
          disabled={!focused}
          onChange={(e) => {
            let txt = fixName(e.target.value);
            setStackName(txt);
            // setInpWidth(inpHidden.current.clientWidth + 14)
            let w = getTextWidth(txt, "bold 33px Arial");
            console.log("w = ", w);
            setInpWidth(w < 120 ? 120 : w > 600 ? 600 : w);
          }}
        />

<MobHideSpan>
  <Flex>
        &nbsp;&nbsp;&nbsp;
        {!focused && (
          <Button left sm flat onClick={() => setFocused(true)}>
            <MIcon size={18} >edit</MIcon>
          </Button>
        )}
        {focused && (
          <Button
            left
            sm
            onClick={() =>
              validateName(stackName) ? saveName(stackName) : void 0
            }
          >
            Save
          </Button>
        )}
        {/* <CSSnameHidden ref={inpHidden}>{stackName}</CSSnameHidden> */}

          {/* <Button flat sm left>
            <MIcon size={18}>link</MIcon>
            <MobHideSpan>&nbsp;&nbsp;Copy stack link</MobHideSpan>
          </Button>

          <Button
            flat
            sm
            onClick={() => {
              deleteHandler();
            }}
          >
            <MIcon size={18}>delete</MIcon>
            <MobHideSpan>&nbsp;&nbsp;Delete stack</MobHideSpan>
          </Button> */}
  </Flex>
</MobHideSpan>






      </CSSh>
      <PopClose handle={closeHandler} />
    </>
  );
}

const CSSh = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 991px) {
    padding: 1em 1em 0em 1em;
  }
`;

const CSSnameHidden = styled.span`
  font-size: 2em;
  font-weight: 500;
  /* visibility: hidden; */
  white-space: nowrap;
  border: 1px solid red;
  /* position: absolute; */
`;

const CSSname = styled.input`
  &:disabled {
    color: black;
  }
  margin-left: -3px;
  position: relative;
  font-family: "Graphik";
  font-size: 2em;
  font-weight: 700;
  width: 300px;
  background: ${({ focused }) => (!focused ? "transparent" : "white")};
  border: 2px solid
    ${({ focused }) => (!focused ? "transparent" : "var(--main-accent-color)")};
  border-radius: 0.2em;
  width: ${({ width }) => `${width}px`};
  max-width: 20em;
`;
